import { Preset } from '@openng/optimus-ui-themes/types';

export const customerOverride = {
	components: {
		button: {
			extend: {
				width: '166px',
			},
		},
		badge: {
			sm: {
				fontSize: '11px',
			},
		},
	},
} satisfies Preset;
